function redirect(url) {
    window.open(url)
}

export { redirect }